(function() {
  'use strict';

  if (window.LayerdevSwatchManager) return;

  window.LayerdevSwatchManager = {
    containers: new Map(),
    counter: 0,
    gridObserver: null,
    bodyObserver: null,
    checkInterval: null,
    resizeTimer: null,
    mutationTimer: null,
    processing: false,
    domSnapshot: '',

    init: function() {
      var self = this;
      
      window.addEventListener('load', function() {
        self.captureSnapshot();
        self.processAll();
        self.startObservers();
        self.startPeriodicCheck();
        self.attachListeners();
      });
    },

    captureSnapshot: function() {
      var containers = document.querySelectorAll('[data-swatch-container]');
      var snapshot = [];
      
      for (var i = 0; i < containers.length; i++) {
        var c = containers[i];
        snapshot.push(c.getAttribute('data-product-id') + ':' + c.querySelectorAll('[data-swatch-item]').length);
      }
      
      this.domSnapshot = snapshot.join('|');
    },

    hasSnapshotChanged: function() {
      var containers = document.querySelectorAll('[data-swatch-container]');
      var current = [];
      
      for (var i = 0; i < containers.length; i++) {
        var c = containers[i];
        current.push(c.getAttribute('data-product-id') + ':' + c.querySelectorAll('[data-swatch-item]').length);
      }
      
      var currentSnapshot = current.join('|');
      var changed = currentSnapshot !== this.domSnapshot;
      
      if (changed) {
        // console.log('[LayerdevSwatchManager] Snapshot changed!');
        // console.log('[LayerdevSwatchManager] Old:', this.domSnapshot.substring(0, 100) + '...');
        // console.log('[LayerdevSwatchManager] New:', currentSnapshot.substring(0, 100) + '...');
        this.domSnapshot = currentSnapshot;
      }
      
      return changed;
    },

    startObservers: function() {
      var grid = document.getElementById('main-collection-product-grid');
      
      if (grid) {
        // console.log('[LayerdevSwatchManager] Grid detected, setting up grid observer');
        this.observeGrid(grid);
      } else {
      }
      
      this.observeBody();
    },

    observeGrid: function(grid) {
      var self = this;
      if (!window.MutationObserver) return;

      this.gridObserver = new MutationObserver(function(mutations) {
        var changed = mutations.some(function(m) { 
          return m.addedNodes.length > 0 || m.removedNodes.length > 0; 
        });
        
        if (!changed) return;

        // console.log('[LayerdevSwatchManager] Grid mutation detected');
        clearTimeout(self.mutationTimer);
        self.mutationTimer = setTimeout(function() {
          if (self.hasSnapshotChanged()) {
            self.resetGrid(grid);
          } else {
            // console.log('[LayerdevSwatchManager] Grid mutation but no snapshot change, ignoring');
          }
        }, 200);
      });

      this.gridObserver.observe(grid, { childList: true, subtree: true });
    },

    resetGrid: function(grid) {
      if (this.processing) return;
      // console.log('[LayerdevSwatchManager] Resetting grid...');
      
      this.processing = true;
      var gridContainers = grid.querySelectorAll('[data-swatch-container]');
      var self = this;
      
      // Clear grid containers
      this.containers.forEach(function(state, id) {
        for (var i = 0; i < gridContainers.length; i++) {
          if (state.container === gridContainers[i]) {
            self.containers.delete(id);
            // console.log('[LayerdevSwatchManager] Removed:', id);
            break;
          }
        }
      });

      // Reinit all
      for (var j = 0; j < gridContainers.length; j++) {
        gridContainers[j].id = '';
        this.processContainer(gridContainers[j]);
      }

      this.processing = false;
    },

    observeBody: function() {
      var self = this;
      if (!window.MutationObserver) return;

      this.bodyObserver = new MutationObserver(function(mutations) {
        var hasNew = mutations.some(function(m) {
          if (m.addedNodes.length === 0) return false;
          
          for (var i = 0; i < m.addedNodes.length; i++) {
            var node = m.addedNodes[i];
            if (node.nodeType === 1 && !node.closest('#main-collection-product-grid')) {
              return true;
            }
          }
          return false;
        });
        
        if (!hasNew) return;

        // console.log('[LayerdevSwatchManager] Body mutation detected');
        clearTimeout(self.mutationTimer);
        self.mutationTimer = setTimeout(function() {
          if (self.processing) return;
          
          if (self.hasSnapshotChanged()) {
            // console.log('[LayerdevSwatchManager] Processing after snapshot change');
            self.processAll();
          } else {
            // console.log('[LayerdevSwatchManager] Body mutation but no snapshot change, ignoring');
          }
        }, 200);
      });

      this.bodyObserver.observe(document.body, { childList: true, subtree: true });
    },

    startPeriodicCheck: function() {
      var self = this;
      // console.log('[LayerdevSwatchManager] Starting periodic check (every 2s)');
      
      this.checkInterval = setInterval(function() {
        if (self.hasSnapshotChanged()) {
          // console.log('[LayerdevSwatchManager] Periodic check: snapshot changed, processing...');
          self.processAll();
        }
      }, 2000);
    },

    attachListeners: function() {
      var self = this;

      document.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-toggle-swatch]');
        if (!btn) return;

        e.preventDefault();
        var container = btn.closest('[data-swatch-container]');
        if (!container) return;

        var state = self.containers.get(container.id);
        if (!state) return;

        state.expanded = !state.expanded;
        // console.log('[LayerdevSwatchManager] Toggle:', container.id, state.expanded ? 'expanded' : 'collapsed');
        self.render(state);
      });

      var lastWidth = window.innerWidth;
      window.addEventListener('resize', function() {
        var newWidth = window.innerWidth;
        if (Math.abs(newWidth - lastWidth) < 100) return;
        
        // console.log('[LayerdevSwatchManager] Resize detected:', lastWidth, '→', newWidth);
        lastWidth = newWidth;

        clearTimeout(self.resizeTimer);
        self.resizeTimer = setTimeout(function() {
          self.recalculateAll();
        }, 250);
      });
    },

    processAll: function() {
      if (this.processing) return;
      // console.log('[LayerdevSwatchManager] Processing all containers...');
      
      this.processing = true;
      var containers = document.querySelectorAll('[data-swatch-container]');
      
      for (var i = 0; i < containers.length; i++) {
        this.processContainer(containers[i]);
      }

      // console.log('[LayerdevSwatchManager] Process complete. Total:', this.containers.size);
      this.processing = false;
    },

    processContainer: function(container) {
      if (!container.id) {
        this.counter++;
        var pid = container.getAttribute('data-product-id') || 'p';
        var ts = Date.now().toString(36);
        container.id = 'sw-' + pid + '-' + ts + '-' + this.counter;
      }

      var id = container.id;
      if (this.containers.has(id)) return;

      var items = this.getDirectChildren(container, '[data-swatch-item]');
      var btn = this.getDirectChildren(container, '[data-swatch-more]')[0];

      if (!items.length || !btn) return;

      var state = {
        id: id,
        container: container,
        items: items,
        btn: btn,
        icon: btn.querySelector('.toggle-icon'),
        count: btn.querySelector('.text-number'),
        expanded: false,
        max: 2
      };

      this.containers.set(id, state);
      // console.log('[LayerdevSwatchManager] Container added:', id, '(' + items.length + ' items)');
      this.calculate(state);
    },

    getDirectChildren: function(container, selector) {
      var all = container.querySelectorAll(selector);
      var direct = [];
      
      for (var i = 0; i < all.length; i++) {
        if (all[i].closest('[data-swatch-container]') === container) {
          direct.push(all[i]);
        }
      }
      
      return direct;
    },

    calculate: function(state) {
      var list = state.container.querySelector('[data-swatch-list]');
      if (!list) return;

      var width = list.clientWidth;
      if (width === 0) return;

      
      for (var i = 0; i < state.items.length; i++) {
        state.items[i].style.display = '';
      }
      state.btn.style.display = '';
      void list.offsetWidth;

      var item = state.items[0];
      var itemStyle = window.getComputedStyle(item);
      var itemW = item.offsetWidth + 
                  parseFloat(itemStyle.marginLeft || 0) + 
                  parseFloat(itemStyle.marginRight || 0);

      var btnStyle = window.getComputedStyle(state.btn);
      var btnW = state.btn.offsetWidth + 
                 parseFloat(btnStyle.marginLeft || 0) + 
                 parseFloat(btnStyle.marginRight || 0);

      if (itemW === 0) return;

      var available = width - btnW - 10;
      var calculated = Math.floor(available / itemW);
      state.max = Math.max(2, Math.min(calculated, state.items.length));

      // console.log('[LayerdevSwatchManager] Calculate:', state.id, '- can show', state.max, 'of', state.items.length);
      this.render(state);
    },

    render: function(state) {
      var total = state.items.length;
      var showAll = state.expanded || state.max >= total;

      for (var i = 0; i < total; i++) {
        state.items[i].style.display = (showAll || i < state.max) ? '' : 'none';
      }

      if (state.max >= total) {
        state.btn.style.display = 'none';
      } else {
        state.btn.style.display = '';
        if (state.icon) state.icon.textContent = showAll ? '-' : '+';
        if (state.count) state.count.textContent = showAll ? '' : (total - state.max);
      }
    },

    recalculateAll: function() {
      // console.log('[LayerdevSwatchManager] Recalculating all...');
      var self = this;
      
      this.containers.forEach(function(state) {
        if (!state.expanded) {
          self.calculate(state);
        }
      });
    },

    destroy: function() {
      // console.log('[LayerdevSwatchManager] Destroying...');
      if (this.gridObserver) this.gridObserver.disconnect();
      if (this.bodyObserver) this.bodyObserver.disconnect();
      if (this.checkInterval) clearInterval(this.checkInterval);
      this.containers.clear();
    }
  };

  window.LayerdevSwatchManager.init();

})();